// extracted by css-extract-rspack-plugin
export default {"cls1":"SeasonalDiscountUnibrow-cls1_E7p","cls2":"SeasonalDiscountUnibrow-cls2_ERz SeasonalDiscountUnibrow-cls1_E7p"};